import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FiHome, FiLock, FiMapPin, FiFilter, FiCalendar, FiLogOut,
  FiChevronDown, FiChevronRight, FiMenu, FiX, FiHelpCircle,
  FiUserCheck, FiUsers, FiFolder,
  FiCpu,
  FiAperture,
  FiPenTool
} from 'react-icons/fi';
import { BsBuilding } from 'react-icons/bs';
import logo2 from "../../../assets/images/logo2.png";
import { MdAnalytics, MdHistory, MdOutlineRealEstateAgent, MdSell } from 'react-icons/md';
import { FaBalanceScale, FaBars, FaBlog, FaQuestionCircle, FaRegStar, FaUserCheck, FaUsers } from 'react-icons/fa';
import '../../../assets/css/Buyer/buyersidebar/buyersidebar.css';
import AppContext from 'context/AppContext';

const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: <FiHome />, path: '/buyer/dashboard' },
  { id: 'wishlist', label: 'Wishlist', icon: <FiUserCheck />, path: '/buyer/properties' },
  { id: 'designvision ai', label: 'DesignVision AI', icon: <FiCpu />, path: '/buyer/map' },
  { id: 'visit request', label: 'Visit Request', icon: <FaUserCheck />, path: '/buyer/visitreq' },
  { id: 'conversations', label: 'Conversations', icon: <FaUsers />, path: '/buyer/chats' },
  { id: 'support ticket', label: 'Help & Support', icon: <FiHelpCircle />, path: '/buyer/support' },

];

// ── Derive active id from current URL path ────────────────────
const getActiveId = (pathname) => {
  // exact match first
  const exact = menuItems.find(m => m.path === pathname);
  if (exact) return exact.id;
  // partial match (e.g. /admin/blogs/edit → blogs)
  const partial = menuItems.find(m => pathname.startsWith(m.path) && m.path !== '/admin/dashboard');
  if (partial) return partial.id;
  // dashboard fallback
  if (pathname === '/buyer' || pathname === '/buyer/') return 'dashboard';
  return '';
};

const BuyerSideBar = ({ isCollapsed, onToggle }) => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { setAuthToken } = useState(AppContext);

  // const [isCollapsed,setIsCollapsed]=useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(true);

  // ── Active state is DERIVED from URL — single source of truth ─
  const activeMenu = getActiveId(location.pathname);
  // Close mobile sidebar on route change
  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const handleMenuClick = (path) => {
    Navigate(path);
    if (window.innerWidth < 768) setIsMobileOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('buyeremail');
    localStorage.removeItem('buyerpassword');
    localStorage.removeItem("buyerId");
    localStorage.removeItem("LoggedInBuyer");
    Navigate('/buyer/login');
  };

  return (
    <>
      {/* ── Mobile Toggle Button ── */}
      <button className="admin-mobile-menu-btn" onClick={() => setIsMobileOpen(s => !s)}>
        {isMobileOpen ? <FiX /> : <FiMenu />}
      </button>

      {/* ── Mobile Overlay ── */}
      {isMobileOpen && (
        <div className="admin-sidebar-overlay" onClick={() => setIsMobileOpen(false)} />
      )}

      {/* ── Sidebar ── */}
      <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>

        {/* Logo */}
        <div className="admin-sidebar-header">
          {!isCollapsed && (
            <a href="/" className="navbar-brand">
              <img src={logo2} alt="Estate Experts" className="navbar-logo" />

              {/* Text block */}
              <div className="navbar-brand-text-wrap">
                <span className="footer-brand-text">Estate Experts</span>
                <span className="footer-brand-tagline">
                  Buy
                  <span className="brand-tagline-dot">◆</span>
                  Sell
                  <span className="brand-tagline-dot">◆</span>
                  Rent
                </span>
              </div>
            </a>
          )}
          <button
            className="admin-sidebar-hamburger"
            onClick={onToggle}
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <FaBars />
          </button>
        </div>

        {/* Nav */}
        <nav className="admin-sidebar-nav">
          <ul className="admin-menu-list">
            {menuItems.map((item) => (
              <li key={item.id} className="admin-menu-item">
                <div
                  className={`admin-menu-link ${activeMenu === item.id ? 'active' : ''}`}
                  onClick={() => handleMenuClick(item.path)}
                  title={isCollapsed ? item.label : ''}
                >
                  <span className="admin-menu-icon">{item.icon}</span>
                  {!isCollapsed && (
                    <span className="admin-menu-label">{item.label}</span>
                  )}
                  {/* Active dot when collapsed */}
                  {isCollapsed && activeMenu === item.id && (
                    <span className="admin-active-dot" />
                  )}
                </div>
              </li>
            ))}
          </ul>
        </nav>

        {/* Logout */}
        <div className="admin-sidebar-footer">
          <button
            className="admin-logout-btn"
            onClick={handleLogout}
            title={isCollapsed ? 'Logout' : ''}
          >
            <span className="admin-menu-icon"><FiLogOut /></span>
            {!isCollapsed && <span className="admin-menu-label">Logout</span>}
          </button>
        </div>
      </div>
    </>
  );
};

export default BuyerSideBar;